module.exports = __webpack_public_path__ + "static/media/mentor.be1d78f0.jpg";